
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexnuYtgPaPdX4tVKehNxVqrLaA1Mm9FvqQEB4ON7qPSKEMeta } from "/app/pages/topics/index.vue?macro=true";
import { default as indexFE_7CXmcNvl7rQRAoMUykenzSLGsvAp06fwHTomNKDEMeta } from "/app/pages/landing/index.vue?macro=true";
import { default as indexfv7IQAkLWpbstdGsoluO9_45YvOAYaswbjPzzmeQ3KEM0Meta } from "/app/pages/scoring/index.vue?macro=true";
import { default as indexMW2VjIu_4rFhLSNdgVR8xG4DubByLtM5X_PutdMKiFQMeta } from "/app/pages/overview/index.vue?macro=true";
import { default as indexksv288D2Puf9VIYIrupNOlve9k9jP72KWRlxLrgm47wMeta } from "/app/pages/playback/index.vue?macro=true";
import { default as indexvEiJX3QpsEUGSsjnSauAj6sA01FuESXlWSg5ZxdTp4UMeta } from "/app/pages/pdfExport/index.vue?macro=true";
import { default as indexz7UXI_TsfUq4Z3wIQ5O6xB0sccy6K4seoOZ_45hHRudf0Meta } from "/app/pages/sentiment/index.vue?macro=true";
import { default as index3fi7B_Le1oe19i4IfGb102O4EJiDy0tuNozSX4nak8QMeta } from "/app/pages/objections/index.vue?macro=true";
import { default as indexaGQBX41dZRwcZqeZq9bN4rEOhix7kYinxBstFsxgKSoMeta } from "/app/pages/maintenance/index.vue?macro=true";
import { default as indexdbVhUMz3shd_45Ogy7hgGKr_aw_6HFndxJE9rX8qzM_7UMeta } from "/app/pages/performance/index.vue?macro=true";
import { default as indexsDgQZBOKzZ3rYZf7KtepykbGQezyxBuOdB69TXI3PGsMeta } from "/app/pages/interactions/index.vue?macro=true";
import { default as indexfwJJlZR8IiPOaxTitB08jUTlRbb4E76f0WT6gCH5n4gMeta } from "/app/pages/prompt-studio/index.vue?macro=true";
import { default as indexEgr_LfVGDiInym0kdWOCtN3Wl6EDuUOGPAieYYqC_45LMMeta } from "/app/pages/interaction/[id]/index.vue?macro=true";
import { default as indexNtSKO9qBJMjmo4AIvKki68NikEwJFI6VIHFbuqdMAC4Meta } from "/app/pages/scoring/scorecards/results/[id]/index.vue?macro=true";
import { default as indexIl8L1eGdExXxasCtFtXhHN8pkAsNEmzvheKhyUj3e1QMeta } from "/app/pages/scoring/schedules/designer/[[id]]/index.vue?macro=true";
import { default as indexvC2kAlue5ggI1vKHqgGG2t14c6hYxw_45NYK4XMK6h3FMMeta } from "/app/pages/scoring/scorecards/designer/[[id]]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "topics",
    path: "/topics",
    meta: { ...(indexnuYtgPaPdX4tVKehNxVqrLaA1Mm9FvqQEB4ON7qPSKEMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/topics/index.vue")
  },
  {
    name: "landing",
    path: "/landing",
    meta: { ...(indexFE_7CXmcNvl7rQRAoMUykenzSLGsvAp06fwHTomNKDEMeta || {}), ...{"middleware":["page-view-tracking"]} },
    component: () => import("/app/pages/landing/index.vue")
  },
  {
    name: "scoring",
    path: "/scoring",
    meta: { ...(indexfv7IQAkLWpbstdGsoluO9_45YvOAYaswbjPzzmeQ3KEM0Meta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/scoring/index.vue")
  },
  {
    name: "overview",
    path: "/overview",
    meta: { ...(indexMW2VjIu_4rFhLSNdgVR8xG4DubByLtM5X_PutdMKiFQMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/overview/index.vue")
  },
  {
    name: "playback",
    path: "/playback",
    meta: { ...(indexksv288D2Puf9VIYIrupNOlve9k9jP72KWRlxLrgm47wMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/playback/index.vue")
  },
  {
    name: "pdfExport",
    path: "/pdfExport",
    meta: { ...(indexvEiJX3QpsEUGSsjnSauAj6sA01FuESXlWSg5ZxdTp4UMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/pdfExport/index.vue")
  },
  {
    name: "sentiment",
    path: "/sentiment",
    meta: { ...(indexz7UXI_TsfUq4Z3wIQ5O6xB0sccy6K4seoOZ_45hHRudf0Meta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/sentiment/index.vue")
  },
  {
    name: "objections",
    path: "/objections",
    meta: { ...(index3fi7B_Le1oe19i4IfGb102O4EJiDy0tuNozSX4nak8QMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/objections/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: { ...(indexaGQBX41dZRwcZqeZq9bN4rEOhix7kYinxBstFsxgKSoMeta || {}), ...{"middleware":["page-view-tracking"]} },
    component: () => import("/app/pages/maintenance/index.vue")
  },
  {
    name: "performance",
    path: "/performance",
    meta: { ...(indexdbVhUMz3shd_45Ogy7hgGKr_aw_6HFndxJE9rX8qzM_7UMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/performance/index.vue")
  },
  {
    name: "interactions",
    path: "/interactions",
    meta: { ...(indexsDgQZBOKzZ3rYZf7KtepykbGQezyxBuOdB69TXI3PGsMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/app/pages/interactions/index.vue")
  },
  {
    name: "prompt-studio",
    path: "/prompt-studio",
    meta: { ...(indexfwJJlZR8IiPOaxTitB08jUTlRbb4E76f0WT6gCH5n4gMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/prompt-studio/index.vue")
  },
  {
    name: "interaction-id",
    path: "/interaction/:id()",
    meta: { ...(indexEgr_LfVGDiInym0kdWOCtN3Wl6EDuUOGPAieYYqC_45LMMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/interaction/[id]/index.vue")
  },
  {
    name: "scoring-scorecards-results-id",
    path: "/scoring/scorecards/results/:id()",
    meta: { ...(indexNtSKO9qBJMjmo4AIvKki68NikEwJFI6VIHFbuqdMAC4Meta || {}), ...{"middleware":["auth","shared-link","page-view-tracking"]} },
    component: () => import("/app/pages/scoring/scorecards/results/[id]/index.vue")
  },
  {
    name: "scoring-schedules-designer-id",
    path: "/scoring/schedules/designer/:id?",
    meta: { ...(indexIl8L1eGdExXxasCtFtXhHN8pkAsNEmzvheKhyUj3e1QMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/scoring/schedules/designer/[[id]]/index.vue")
  },
  {
    name: "scoring-scorecards-designer-id",
    path: "/scoring/scorecards/designer/:id?",
    meta: { ...(indexvC2kAlue5ggI1vKHqgGG2t14c6hYxw_45NYK4XMK6h3FMMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/app/pages/scoring/scorecards/designer/[[id]]/index.vue")
  }
]